export const fetchWebhooks = () => {
    return {
        method: 'GET',
        url: '/tenant/webhooks'
    };
};

export const updateWebhook = (webhookId, data) => {
    return {
        method: 'PUT',
        url: `/tenant/webhooks/${webhookId}`,
        data
    };
};

export const updateTenant = (data) => {
    return {
        method: 'PUT',
        url: '/tenant',
        data
    };
};

export const createWebhook = (data) => {
    return {
        method: 'POST',
        url: '/tenant/webhooks',
        data
    };
};

export const deleteWebhook = ({ webhookId }) => {
    return {
        method: 'DELETE',
        url: `/tenant/webhooks/${webhookId}`
    };
};

export const testWebhook = ({ webhookId }) => {
    return {
        method: 'POST',
        url: `/tenant/webhooks/${webhookId}/test`
    };
};

export const contractTypes = () => {
    return {
        method: 'GET',
        url: '/contract-types/parsed'
    };
};

export const deleteContractType = typeId => {
    return {
        method: 'DELETE',
        url: `/contract-types/${typeId}`
    };
};

export const updateContractType = (typeId, data) => {
    return {
        method: 'PUT',
        url: `/contract-types/${typeId}`,
        data
    };
};

export const createContractType = (data) => {
    return {
        method: 'POST',
        url: '/contract-types',
        data
    };
};